<div class="file-upload pointer-events-none" (clickOutside)="isOptionShown = false">
  <div
    [class.disabled]="isLoading"
    (click)="isOptionShown = !isOptionShown"
    (clickOutside)="isOptionShown = false"
  >
    <span
      *ngIf="!isLoading"
      [innerHTML]="renderedTemplate | safeHtml"
      [ngStyle]="contentStyle"
      class="file-label"
    >
    </span>
    <span *ngIf="isLoading" [ngStyle]="contentStyle" class="file-label">Uploading...</span>
  </div>

  <div class="option-list w-100" *ngIf="isOptionShown">
    <div class="is-space-between p-2 item" (click)="cameraPhoto.click()">
      <span class="label ml-2"> Take a photo </span>
      <mat-icon class="mr-4" [svgIcon]="'camera'" [ngStyle]="iconSize"></mat-icon>
    </div>

    <div class="is-space-between p-2 item" (click)="fileInput.click()">
      <span class="label ml-2"> Select a photo </span>
      <mat-icon class="mr-4" [svgIcon]="'gallery-image'" [ngStyle]="iconSize"></mat-icon>
    </div>

    <div class="is-space-between p-2 item" (click)="documentInput.click()">
      <span class="label ml-2"> Upload a document </span>
      <mat-icon class="mr-4" [svgIcon]="'file'" [ngStyle]="iconSize"></mat-icon>
    </div>
  </div>

  <!-- to capture photo from camera -->
  <input
    (change)="onChangeFileInput($event)"
    class="file-input"
    #cameraPhoto
    id="cameraPhoto"
    type="file"
    accept="image/*"
    capture="user"
    [(ngModel)]="fileUploads"
  />

  <!-- to select image -->
  <input
    (change)="onChangeFileInput($event)"
    type="file"
    #fileInput
    id="fileInput"
    class="file-input"
    multiple="false"
    min="1"
    max="1"
    [accept]="supportedFileType"
    [(ngModel)]="fileUploads"
  />

  <!-- to select image or document -->
  <input
    (change)="onChangeFileInput($event)"
    type="file"
    #documentInput
    id="documentInput"
    class="file-input"
    multiple="false"
    min="1"
    max="1"
    [accept]="allSupportedFileType"
    [(ngModel)]="fileUploads"
  />
</div>
